import React, { useEffect } from "react";
import { CloseRounded } from "@mui/icons-material";
import { fdcNavigation } from "./fdcNavigation";

export default function FDCMobileNavigation({ open, onClose, page, onNavigate, user, onLogout, unread, messagesUnread }) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;
  return (
    <div className="fdcMobileOverlay" onClick={onClose}>
      <aside className="fdcMobileDrawer" onClick={e => e.stopPropagation()}>
        <div className="fdcMobileProfile">
          <div className="fdcAvatar large">{user.initials}</div>
          <div><strong>{user.firstName} {user.lastName}</strong><span>{user.level} • {user.branch}</span></div>
          <button className="fdcIconButton" onClick={onClose} aria-label="Close navigation"><CloseRounded /></button>
        </div>
        <div className="fdcMobileNavScroll">
          {fdcNavigation.map(group => (
            <div className="fdcNavGroup" key={group.group}>
              <p className="fdcNavGroupLabel">{group.group}</p>
              {group.items.map(item => {
                const Icon = item.icon; const badge=item.page==="notifications"?unread:item.page==="messages"?messagesUnread:0;
                return <button key={item.page}
                  className={`fdcNavItem ${page === item.page ? "active" : ""}`}
                  onClick={() => { onNavigate(item.page); onClose(); }}>
                  <span className="fdcNavItemMain"><Icon className="fdcNavIcon"/><span>{item.label}</span></span>
                  {badge ? <span className="fdcNavBadge">{badge}</span> : null}
                </button>
              })}
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
}
